<template>
  <users-input-list-item
    v-bind="$props"
    :is-users="true"
    :items="dots"
    :color="groupColor"
    :group="groupName"
    :single-login="singleLogin"
    @block="emitEvent('block')"
    @unblock="emitEvent('unblock')"
    @delete="emitEvent('delete')"
    @edit="emitEvent('edit')"
    @logOut="emitEvent('logOut')"
  >
  </users-input-list-item>
</template>

<script>
import { get } from 'vuex-pathify';
import UsersInputListItem from '@/components/UsersInputListItem';

export default {
  name: 'UsersInputListItemWrapper',
  components: {
    UsersInputListItem,
  },
  props: {
    blocked: {
      type: Boolean,
      required: true,
    },
    deleted: {
      type: Boolean,
      required: true,
    },
    is_admin: {
      type: Boolean,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    email: {
      type: String,
      default: '',
    },
    group_id: {
      type: Number,
      default: null,
    },
    is_logged_id: {
      type: Boolean,
    },
  },
  computed: {
    dots() {
      if (this.currentUserId === this.id) {
        return [
          {
            name: 'edit',
          },
        ];
      }
      return [
        {
          name: this.blocked ? 'unblock' : 'block',
        },
        {
          name: 'edit',
        },
        {
          name: 'delete',
        },
        ...(this.is_logged_id
          ? [
              {
                name: 'logOut',
              },
            ]
          : []),
      ];
    },
    groupName: get('users/groups@:group_id.name'),
    groupColor: get('users/groups@:group_id.color'),
    currentUserId: get('users/currentUser@id'),
    singleLogin: get('admin/settingsValues@single_login_per_user'),
  },
  methods: {
    emitEvent(type) {
      this.$emit('dotsItemClicked', { type, id: this.id });
    },
  },
};
</script>

<style lang="scss" scoped></style>
